<template>
    <div class="flex flex-row">
        <form @submit.prevent="handleSubmit" class="form-container" data-cy="form-container">
            <div class="form-section flex flex-col">
                <div
                    class="text-3xl mb-2 pb-2 font-light flex items-end justify-between ml-4 borderline"
                    data-cy="cover-information-form-header"
                    id="cover-information"
                >
                    <div>
                        {{ $t('covers.forms.title.cascade_cover_info') }}
                    </div>
                </div>
            </div>
            <div class="flex flex-row w-full pl-4 pb-4">
                <div data-cy="cascade_description">
                    {{
                        $t('covers.forms.main.cascade_description', {
                            policy_number: cover.insurer_policy_number,
                        })
                    }}
                </div>
            </div>
            <div class="flex flex-row-reverse justify-between w-full pl-4">
                <div class="flex flex-row" data-cy="cascade_record_count">
                    <div>{{ $t('covers.forms.main.record_count') }}</div>
                    <div>{{ cover.record_count }}</div>
                </div>
                <div v-if="companyType == 'insurer'" class="flex flex-row" data-cy="cascade_policy_number">
                    <div>{{ $t('covers.forms.main.policy_number') }}</div>
                    <div>{{ cover.insurer_policy_number }}</div>
                </div>
            </div>
            <div class="form-section flex flex-col">
                <div class="section-body w-full flex flex-row ml-4" data-cy="section-general">
                    <div
                        v-if="companyType == 'insurer'"
                        class="input-container flex flex-col mb-2 pr-4 w-full"
                        data-cy="cover-intermediary-field"
                    >
                        <div class="w-1/2">
                            <div class="flex flex-row justify-between mb-2">
                                <ui-label>{{ $t('covers.forms.main.intermediary') }}</ui-label>
                                <a-switch
                                    :disabled="cover.intermediary_id == '' || cover.intermediary_id == null"
                                    v-model:checked="data.intermediary_id"
                                />
                            </div>
                            <ui-input :value="cover.intermediary_name" :disabled="true"></ui-input>
                        </div>
                    </div>
                    <div
                        v-if="companyType != 'insurer'"
                        class="input-container flex flex-col mb-2 pr-4 w-1/2"
                        data-cy="cover-insurer-field"
                    >
                        <div class="flex flex-row justify-between mb-2">
                            <ui-label>{{ $t('covers.forms.main.insurer') }}</ui-label>
                            <a-switch
                                :disabled="cover.company_id == '' || cover.company_id == null"
                                v-model:checked="data.company_id"
                            />
                        </div>
                        <ui-input :value="cover.insurer_name" :disabled="true"></ui-input>
                    </div>
                    <div
                        v-if="companyType != 'insurer'"
                        class="input-container flex flex-col mb-2 pr-4 w-1/2"
                        data-cy="cover-policy-number-field"
                    >
                        <div class="flex flex-row justify-between mb-2">
                            <ui-label>{{ $t('covers.forms.main.policy_no') }}</ui-label>
                            <a-switch :disabled="true" v-model:checked="data.company_id" />
                        </div>
                        <ui-input :value="cover.insurer_policy_number" :disabled="true"></ui-input>
                    </div>
                    <div class="input-container flex flex-col mb-2 pr-4 w-1/2" data-cy="cover-policy-start-field">
                        <div class="flex flex-row justify-between mb-2">
                            <ui-label>{{ $t('covers.forms.main.policy_start_date') }}</ui-label>
                            <a-switch
                                :disabled="cover.policy_start_date == '' || cover.policy_start_date == null"
                                v-model:checked="data.policy_start_date"
                            />
                        </div>
                        <ui-input :value="cover.policy_start_date" :disabled="true"></ui-input>
                    </div>
                    <div class="input-container flex flex-col mb-2 pr-4 w-1/2" data-cy="cover-policy-end-field">
                        <div class="flex flex-row justify-between mb-2">
                            <ui-label>{{ $t('covers.forms.main.policy_end_date') }}</ui-label>
                            <a-switch
                                :disabled="cover.policy_end_date == '' || cover.policy_end_date == null"
                                v-model:checked="data.policy_end_date"
                            />
                        </div>
                        <ui-input :value="cover.policy_end_date" :disabled="true"></ui-input>
                    </div>
                    <div class="input-container flex flex-col mb-2 pr-4 w-1/2" data-cy="cover-effective-date-field">
                        <div class="flex flex-row justify-between mb-2">
                            <ui-label>{{ $t('covers.forms.main.cover_effective_date') }}</ui-label>
                            <a-switch
                                :disabled="cover.cover_effective_date == '' || cover.cover_effective_date == null"
                                v-model:checked="data.cover_effective_date"
                            />
                        </div>
                        <ui-input :value="cover.cover_effective_date" :disabled="true"></ui-input>
                    </div>
                    <div class="input-container flex flex-col mb-2 pr-4 w-1/2" data-cy="cover-expiry-date-field">
                        <div class="flex flex-row justify-between mb-2">
                            <ui-label>{{ $t('covers.forms.main.cover_expiry_date') }}</ui-label>
                            <a-switch
                                :disabled="cover.cover_expiry_date == '' || cover.cover_expiry_date == null"
                                v-model:checked="data.cover_expiry_date"
                            />
                        </div>
                        <ui-input :value="cover.cover_expiry_date" :disabled="true"></ui-input>
                    </div>
                    <div class="input-container flex flex-col mb-2 w-1/2 pr-4" data-cy="cover-certificate-type-field">
                        <div class="flex flex-row justify-between mb-2">
                            <ui-label>
                                {{ $t('covers.forms.main.certificate_type') }}
                            </ui-label>
                            <a-switch
                                :disabled="cover.certificate_type == '' || cover.certificate_type == null"
                                v-model:checked="data.certificate_type"
                            />
                        </div>
                        <ui-input :value="cover.certificate_type" :disabled="true"></ui-input>
                    </div>
                    <div class="input-container flex flex-col mb-2 w-1/2 pr-4" data-cy="cover-motor-trade-field">
                        <div class="flex flex-row justify-between mb-2">
                            <ui-label>
                                {{ $t('covers.forms.main.is_motor_trade') }}
                            </ui-label>
                            <a-switch v-model:checked="data.is_motor_trade" />
                        </div>
                        <ui-input :value="isMotorTrade" :disabled="true"></ui-input>
                    </div>
                    <div class="input-container flex flex-col mb-2 w-1/2 pr-4" data-cy="cover-cover-type-field">
                        <div class="flex flex-row justify-between mb-2">
                            <ui-label>{{ $t('covers.forms.main.cover_type') }}</ui-label>
                            <a-switch
                                :disabled="cover.cover_type == '' || cover.cover_type == null"
                                v-model:checked="data.cover_type"
                            />
                        </div>
                        <ui-input :value="cover.cover_type" :disabled="true"></ui-input>
                    </div>
                    <div class="input-container flex flex-col mb-2 w-1/2 pr-4" data-cy="cover-cover-category-field">
                        <div class="flex flex-row justify-between mb-2">
                            <ui-label>{{ $t('covers.forms.main.cover_category') }}</ui-label>
                            <a-switch
                                :disabled="cover.cover_category == '' || cover.cover_category == null"
                                v-model:checked="data.cover_category"
                            />
                        </div>
                        <ui-input :value="cover.cover_category" :disabled="true"></ui-input>
                    </div>
                    <div class="input-container flex flex-col mb-2 w-full pr-4" data-cy="cover-address-field">
                        <div class="flex flex-row justify-between mb-2">
                            <ui-label>{{ $t('covers.forms.main.address') }}</ui-label>
                            <a-switch
                                :disabled="cover.policyholder_address == '' || cover.policyholder_address == null"
                                v-model:checked="data.policyholder_address"
                            />
                        </div>
                        <ui-text-area :value="cover.policyholder_address" :disabled="true"></ui-text-area>
                    </div>
                    <div class="input-container flex flex-col mb-2 w-1/2 pr-4" data-cy="cover-risk-mortgagee-field">
                        <div class="flex flex-row justify-between mb-2">
                            <ui-label>{{ $t('covers.forms.main.risk_mortgagee') }}</ui-label>
                            <a-switch
                                :disabled="cover.risk_mortgagee == '' || cover.risk_mortgagee == null"
                                v-model:checked="data.risk_mortgagee"
                            />
                        </div>
                        <ui-input :value="cover.risk_mortgagee" :disabled="true"></ui-input>
                    </div>
                    <div class="input-container flex flex-col mb-2 w-1/2 pr-4" data-cy="cover-manual-cert-field">
                        <div class="flex flex-row justify-between mb-2">
                            <ui-label>{{ $t('covers.forms.main.manual_cert_no') }}</ui-label>
                            <a-switch
                                :disabled="
                                    cover.manual_certificate_number == '' || cover.manual_certificate_number == null
                                "
                                v-model:checked="data.manual_certificate_number"
                            />
                        </div>
                        <ui-input :value="cover.manual_certificate_number" :disabled="true"></ui-input>
                    </div>
                    <div class="input-container flex flex-col mb-2 w-full pr-4" data-cy="cover-section-one-label-field">
                        <div class="flex flex-row justify-between mb-2">
                            <ui-label>{{ $t('covers.forms.main.section_1_label') }}</ui-label>
                            <a-switch
                                :disabled="cover.section_1_label == '' || cover.section_1_label == null"
                                v-model:checked="data.section_1_label"
                            />
                        </div>
                        <ui-input :value="cover.section_1_label" :disabled="true"></ui-input>
                    </div>
                    <div class="input-container flex flex-col mb-2 w-full pr-4" data-cy="cover-section-one-field">
                        <div class="flex flex-row justify-between mb-2">
                            <ui-label>{{ $t('covers.forms.main.section_1') }}</ui-label>
                            <a-switch
                                :disabled="cover.section_1 == '' || cover.section_1 == null"
                                v-model:checked="data.section_1"
                            />
                        </div>
                        <ui-text-area :value="cover.section_1" :disabled="true"></ui-text-area>
                    </div>
                    <div class="input-container flex flex-col mb-2 w-full pr-4" data-cy="cover-section-two-label-field">
                        <div class="flex flex-row justify-between mb-2">
                            <ui-label>{{ $t('covers.forms.main.section_2_label') }}</ui-label>
                            <a-switch
                                :disabled="cover.section_2_label == '' || cover.section_2_label == null"
                                v-model:checked="data.section_2_label"
                            />
                        </div>
                        <ui-input :value="cover.section_2_label" :disabled="true"></ui-input>
                    </div>
                    <div class="input-container flex flex-col mb-2 w-full pr-4" data-cy="cover-section-two-field">
                        <div class="flex flex-row justify-between mb-2">
                            <ui-label>{{ $t('covers.forms.main.section_2') }}</ui-label>
                            <a-switch
                                :disabled="cover.section_2 == '' || cover.section_2 == null"
                                v-model:checked="data.section_2"
                            />
                        </div>
                        <ui-text-area :value="cover.section_2" :disabled="true"></ui-text-area>
                    </div>
                    <div
                        class="input-container flex flex-col mb-2 w-full pr-4"
                        data-cy="cover-section-three-label-field"
                    >
                        <div class="flex flex-row justify-between mb-2">
                            <ui-label>{{ $t('covers.forms.main.section_3_label') }}</ui-label>
                            <a-switch
                                :disabled="cover.section_3_label == '' || cover.section_3_label == null"
                                v-model:checked="data.section_3_label"
                            />
                        </div>
                        <ui-input :value="cover.section_3_label" :disabled="true"></ui-input>
                    </div>
                    <div class="input-container flex flex-col mb-2 w-full pr-4" data-cy="cover-section-three-field">
                        <div class="flex flex-row justify-between mb-2">
                            <ui-label>{{ $t('covers.forms.main.section_3') }}</ui-label>
                            <a-switch
                                :disabled="cover.section_3 == '' || cover.section_3 == null"
                                v-model:checked="data.section_3"
                            />
                        </div>
                        <ui-text-area :value="cover.section_3" :disabled="true"></ui-text-area>
                    </div>
                    <div
                        class="input-container flex flex-col mb-2 w-full pr-4"
                        data-cy="cover-section-four-label-field"
                    >
                        <div class="flex flex-row justify-between mb-2">
                            <ui-label>{{ $t('covers.forms.main.section_4_label') }}</ui-label>
                            <a-switch
                                :disabled="cover.section_4_label == '' || cover.section_4_label == null"
                                v-model:checked="data.section_4_label"
                            />
                        </div>
                        <ui-input :value="cover.section_4_label" :disabled="true"></ui-input>
                    </div>
                    <div class="input-container flex flex-col mb-2 w-full pr-4" data-cy="cover-section-four-field">
                        <div class="flex flex-row justify-between mb-2">
                            <ui-label>{{ $t('covers.forms.main.section_4') }}</ui-label>
                            <a-switch
                                :disabled="cover.section_4 == '' || cover.section_4 == null"
                                v-model:checked="data.section_4"
                            />
                        </div>
                        <ui-text-area :value="cover.section_4" :disabled="true"></ui-text-area>
                    </div>
                </div>
            </div>
            <div class="form-section flex flex-col">
                <div
                    class="text-3xl mb-2 pb-2 font-light flex items-end justify-between ml-4 borderline"
                    data-cy="vehicle-information-form-header"
                    id="vehicle-information"
                >
                    <div>
                        {{ $t('covers.forms.title.vehicle_info') }}
                    </div>
                </div>
            </div>
            <div class="form-section flex flex-col">
                <div class="section-body w-full flex flex-row ml-4">
                    <div
                        class="input-container flex flex-col mb-2 w-1/2 pr-4"
                        data-cy="vehicle-section-registration-number-field"
                    >
                        <div class="flex flex-row justify-between mb-2">
                            <ui-label>{{ $t('covers.forms.main.registration_number') }}</ui-label>
                            <a-switch
                                :disabled="cover.registration_number == '' || cover.registration_number == null"
                                v-model:checked="data.registration_number"
                            />
                        </div>
                        <ui-input :value="cover.registration_number" :disabled="true"></ui-input>
                    </div>
                    <div
                        class="input-container flex flex-col mb-2 w-1/2 pr-4"
                        data-cy="vehicle-section-chassis-number-field"
                    >
                        <div class="flex flex-row justify-between mb-2">
                            <ui-label>{{ $t('covers.forms.main.chassis_number') }} </ui-label>
                            <a-switch
                                :disabled="cover.chassis_number == '' || cover.chassis_number == null"
                                v-model:checked="data.chassis_number"
                            />
                        </div>
                        <ui-input :value="cover.chassis_number" :disabled="true"></ui-input>
                    </div>
                    <div
                        class="input-container flex flex-col mb-2 w-1/2 pr-4"
                        data-cy="vehicle-section-vehicle-make-field"
                    >
                        <div class="flex flex-row justify-between mb-2">
                            <ui-label>{{ $t('covers.forms.main.vehicle_make') }}</ui-label>
                            <a-switch
                                :disabled="cover.vehicle_make == '' || cover.vehicle_make == null"
                                v-model:checked="data.vehicle_make"
                            />
                        </div>
                        <ui-input :value="cover.vehicle_make" :disabled="true"></ui-input>
                    </div>
                    <div
                        class="input-container flex flex-col mb-2 w-1/2 pr-4"
                        data-cy="vehicle-section-vehicle-model-field"
                    >
                        <div class="flex flex-row justify-between mb-2">
                            <ui-label>{{ $t('covers.forms.main.vehicle_model') }}</ui-label>
                            <a-switch
                                :disabled="cover.vehicle_model == '' || cover.vehicle_model == null"
                                v-model:checked="data.vehicle_model"
                            />
                        </div>
                        <ui-input :value="cover.vehicle_model" :disabled="true"></ui-input>
                    </div>
                    <div
                        class="input-container flex flex-col mb-2 w-1/2 pr-4"
                        data-cy="vehicle-section-vehicle-year-field"
                    >
                        <div class="flex flex-row justify-between mb-2">
                            <ui-label>{{ $t('covers.forms.main.vehicle_year') }}</ui-label>
                            <a-switch
                                :disabled="cover.vehicle_year == '' || cover.vehicle_year == null"
                                v-model:checked="data.vehicle_year"
                            />
                        </div>
                        <ui-input :value="cover.vehicle_year" :disabled="true"></ui-input>
                    </div>
                    <div
                        class="input-container flex flex-col mb-2 w-1/2 pr-4"
                        data-cy="vehicle-section-vehicle-color-field"
                    >
                        <div class="flex flex-row justify-between mb-2">
                            <ui-label>{{ $t('covers.forms.main.vehicle_color') }}</ui-label>
                            <a-switch
                                :disabled="cover.vehicle_color == '' || cover.vehicle_color == null"
                                v-model:checked="data.vehicle_color"
                            />
                        </div>
                        <ui-input :value="cover.vehicle_color" :disabled="true"></ui-input>
                    </div>
                    <div
                        class="input-container flex flex-col mb-2 w-1/2 pr-4"
                        data-cy="vehicle-section-engine-number-field"
                    >
                        <div class="flex flex-row justify-between mb-2">
                            <ui-label>{{ $t('covers.forms.main.engine_number') }}</ui-label>
                            <a-switch
                                :disabled="cover.engine_number == '' || cover.engine_number == null"
                                v-model:checked="data.engine_number"
                            />
                        </div>
                        <ui-input :value="cover.engine_number" :disabled="true"></ui-input>
                    </div>
                    <div
                        class="input-container flex flex-col mb-2 w-1/2 pr-4"
                        data-cy="vehicle-section-sum-insured-field"
                    >
                        <div class="flex flex-row justify-between mb-2">
                            <ui-label>{{ $t('covers.forms.main.sum_insured') }}</ui-label>
                            <a-switch
                                :disabled="cover.sum_insured == '' || cover.sum_insured == null"
                                v-model:checked="data.sum_insured"
                            />
                        </div>
                        <ui-input :value="cover.sum_insured" :disabled="true"></ui-input>
                    </div>
                    <div class="input-container flex flex-col mb-2 w-1/2 pr-4" data-cy="vehicle-section-hpcc-field">
                        <div class="flex flex-row justify-between mb-2">
                            <ui-label>{{ $t('covers.forms.main.hpcc') }}</ui-label>
                            <a-switch :disabled="cover.hpcc == '' || cover.hpcc == null" v-model:checked="data.hpcc" />
                        </div>
                        <ui-input :value="cover.hpcc" :disabled="true"></ui-input>
                    </div>
                    <div class="input-container flex flex-col mb-2 w-1/2 pr-4" data-cy="vehicle-section-seating-field">
                        <div class="flex flex-row justify-between mb-2">
                            <ui-label>{{ $t('covers.forms.main.seating') }}</ui-label>
                            <a-switch
                                :disabled="cover.seating == '' || cover.seating == null"
                                v-model:checked="data.seating"
                            />
                        </div>
                        <ui-input :value="cover.seating" :disabled="true"></ui-input>
                    </div>
                </div>
            </div>
        </form>
    </div>
</template>

<script>
import UiLabel from '@/components/ui/Label.vue';
import UiCheckbox from '@/components/ui/Checkbox.vue';
import UiInput from '@/components/ui/Input.vue';
import UiTextArea from '@/components/ui/TextArea.vue';

export default {
    components: {
        UiLabel,
        UiCheckbox,
        UiInput,
        UiTextArea,
    },
    props: {
        cover: Object,
        data: Object,
    },
    computed: {
        isMotorTrade() {
            return this.cover.is_motor_trade
                ? this.$t('globals.global.confirm.yes')
                : this.$t('globals.global.confirm.no');
        },
        companyType() {
            return this.$store.state.user.company.company_type;
        },
    },
};
</script>
